import React from 'react'
import ResetPasswordWidget from './reset_password_widget'

function ResetPassword() {
  return (
    <div>
        <ResetPasswordWidget/>
    </div>
  )
}

export default ResetPassword